var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goBack",style:(_vm.styleName),on:{"click":_vm.goBack}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v(" 返回 ")])}
var staticRenderFns = []

export { render, staticRenderFns }